import React, { ReactNode, useState } from "react";
import { PaywallContext } from "./context";
import { useOpenBilling } from "@/hooks/useOpenBilling";
import { SkillPaywallModal } from "@/contexts/PaywallContext/components/SkillPaywallModal";
import { OpenSkillPaywallModalProps } from "@/contexts/PaywallContext/types";
import { CasePaywallModal } from "./components/CasePaywallModal";
import { UsagePaywallModal } from "./components/UsagePaywallModal/UsagePaywallModal";
import { PaywallModal } from "./components/PaywallModal";

interface PaywallProviderProps {
  children: ReactNode;
}

export const PaywallProvider = ({ children }: PaywallProviderProps) => {
  const openBilling = useOpenBilling();
  const [usagePaywallModalOpen, setUsagePaywallModalOpen] = useState(false);
  const [casePaywallModalOpen, setCasePaywallModalOpen] = useState(false);
  const [paywallModalOpen, setPaywallModalOpen] = useState(false);
  const [skillPaywallModalProps, setSkillPaywallModalProps] = useState<OpenSkillPaywallModalProps | undefined>(
    undefined
  );

  const openPaywall = React.useCallback(() => {
    setPaywallModalOpen(true);
  }, []);

  const openSkillPaywall = React.useCallback((props: OpenSkillPaywallModalProps) => {
    setSkillPaywallModalProps({
      ...props,
    });
  }, []);

  const openUsagePaywall = React.useCallback(() => {
    setUsagePaywallModalOpen(true);
  }, []);

  const openCasePaywall = React.useCallback(() => {
    setCasePaywallModalOpen(true);
  }, []);

  function closePaywall() {
    setPaywallModalOpen(false);
    setUsagePaywallModalOpen(false);
    setCasePaywallModalOpen(false);
    setSkillPaywallModalProps(undefined);
  }

  function openBillingCallback() {
    void openBilling();
    closePaywall();
  }

  return (
    <PaywallContext.Provider
      value={{
        openPaywall,
        openSkillPaywall,
        openUsagePaywall,
        openCasePaywall,
      }}
    >
      {children}

      <PaywallModal open={paywallModalOpen} onClose={closePaywall} onOpenBilling={openBillingCallback} />

      <UsagePaywallModal
        open={usagePaywallModalOpen}
        onClose={() => setUsagePaywallModalOpen(false)}
        onOpenBilling={openBillingCallback}
      />

      <CasePaywallModal
        open={casePaywallModalOpen}
        onClose={() => setCasePaywallModalOpen(false)}
        onOpenBilling={openBillingCallback}
      />

      {skillPaywallModalProps && (
        <SkillPaywallModal
          open={true}
          onClose={() => setSkillPaywallModalProps(undefined)}
          onOpenBilling={openBillingCallback}
          availabilityPlans={skillPaywallModalProps.availabilityPlans}
          skillName={skillPaywallModalProps.skillName}
        />
      )}
    </PaywallContext.Provider>
  );
};
